<template>
    <div>
        <div>
            <button
            class="bg-bd text-14 px-4 py-1 text-bg block shadow-[2px_2px_2px_#ccc]"
            @pointerup="$router.push({name:'userIndex'})"
            >返回</button>
        </div>
        <div class="text-center w-150 mx-auto">
            
            <img
            class="block w-150 border-1 border-solid border-bd"
            src="/images/do.png" alt="">
        </div>
    </div>
</template>
<script>
export default{

}
</script>
<style scoped>
</style>